import { FormControl, Validators } from '@angular/forms';
import { FileInput } from '../ui/file-input/file-input.model';

export class CustomFileValidators implements Validators {
  static validarExtensao(type: string, mensagem?: string) {
    return (control: FormControl) => {
      const file = control.value;
      if (file) {
        let filenameSplited;
        if (file.fileNames) {
          filenameSplited = file.fileNames.split('.');
        } else if (file.lenght > 0) {
          filenameSplited = file[0].name.split('.');
        }
        if (filenameSplited){
          const extension = filenameSplited[
          filenameSplited.length - 1
              ].toLowerCase();
          if (type.toLowerCase() !== extension.toLowerCase()) {
            const key = mensagem ? mensagem : 'MSG006';
            return {[key]: true};
          }
        }
        return null;
      }
      return null;
    };
  }

  static validarExtensoes(types: string[], mensagem?: string) {
    return (control: FormControl) => {
      const file = control.value;
      if (file) {
        let filenameSplited;
        if (file.fileNames) {
          filenameSplited = file.fileNames.split('.');
        } else if (file.lenght > 0) {
          filenameSplited = file[0].name.split('.');
        }
        if (filenameSplited){
          const extension = filenameSplited[
          filenameSplited.length - 1
              ].toLowerCase();
          let erro = true;
          types.forEach(type => {
            if (type.toLowerCase() === extension.toLowerCase()) {
              erro = false;
            }
          });
          if (erro) {
            const key = mensagem ? mensagem : 'MSG006';
            return {[key]: erro};
          }
        }
        return null;
      }
      return null;
    };
  }

  static validarTamanhoMaximoEmBytes(tamanhoMaximo: number, mensagem?: string) {
    return (control: FormControl) => {
      const file: FileInput = control.value;
      if (file) {
        if (file.files && file.files[0].size > tamanhoMaximo) {
          const key = mensagem ? mensagem : 'MSG009';
          return {[key]: true};
        }
        return null;
      }
      return null;
    };
  }
}
